import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/media/jobbuddymascot.webp'


const _withScopeId = n => (_pushScopeId("data-v-ad6fd430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar bg-white border-end" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center p-3 mb-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "JobBuddy Logo",
    class: "me-2 jobbuddy-logo",
    style: {"width":"32px","height":"32px"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, [
    /*#__PURE__*/_createTextVNode("Job"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Buddy")
  ])
], -1))
const _hoisted_3 = { class: "nav-section mb-auto" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-speedometer2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Applications", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-vcard" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resumes", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-text" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cover Letters", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-mic" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Interview Practice", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Stats", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-kanban" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Taskboard", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-heart" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Feedback", -1))
const _hoisted_18 = { class: "plan-box" }
const _hoisted_19 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-star text-muted" }, null, -1))
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Applications", -1))
const _hoisted_24 = {
  class: "progress mb-3",
  style: {"height":"4px"}
}
const _hoisted_25 = { class: "user-box" }
const _hoisted_26 = { class: "d-flex align-items-center gap-2" }
const _hoisted_27 = {
  key: 0,
  class: "user-avatar"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "avatar-placeholder"
}
const _hoisted_30 = { class: "user-info d-flex align-items-center" }
const _hoisted_31 = { class: "user-email text-truncate" }
const _hoisted_32 = { class: "dropdown" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-gear ms-4 settings-icon",
  "data-bs-toggle": "dropdown"
}, null, -1))
const _hoisted_34 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person me-2" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-right me-2" }, null, -1))

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from "vue-router";
import store from "../store";
import { SubscriptionsApiService } from "@/services/SubscriptionsApiService";
import { SubscriptionControlledActions } from "@models/SystemEnums";
import Subscribe from "@/views/Subscribe.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const router = useRouter();
const { user, logout: auth0Logout, isAuthenticated } = useAuth0();
const jbUser = ref({});
const userAvatar = computed(() => user.value?.picture);
const userInitials = computed(() => {
  if (!user.value.name) return "👤";
  return user.value.name
    .split(" ")
    .map((name) => name[0])
    .join("")
    .toUpperCase();
});

const applicationQuota = ref({ quota: 0, usage: 0 });
const isLoading = ref(true);
const showSubscribeModal = ref(false);

const logout = () => {
  auth0Logout({ returnTo: window.location.origin });
};

async function loadUserData() {
  try {
    isLoading.value = true;
    jbUser.value = await store.getters["user/getLoggedInUser"];
    await updateQuota();
  } catch (error) {
    console.error("Failed to load user data:", error);
  } finally {
    isLoading.value = false;
  }
}

// Watch for auth state changes
watch(
  isAuthenticated,
  async (isAuth) => {
    if (isAuth) {
      await loadUserData();
    }
  },
  { immediate: true }
);

onMounted(() => {
  // Only add event listener, data loading is handled by the watcher
  window.addEventListener("application-created", updateQuota);
});

// Add cleanup
onUnmounted(() => {
  window.removeEventListener("application-created", updateQuota);
});

// Separate function to update quota
async function updateQuota() {
  try {
    const response = await SubscriptionsApiService.getUserQuota(
      SubscriptionControlledActions.CREATE_APPLICATION
    );
    applicationQuota.value = response.data;
  } catch (error) {
    console.error("Failed to update quota:", error);
    applicationQuota.value = { quota: 0, usage: 0 };
  }
}

async function upgradePlan() {
  router.push({ path: "/subscribe", replace: true });
}

function humanisePlan(plan: string) {
  return plan.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

function handleImageError(event: Event) {
  const target = event.target as HTMLImageElement;
  const parent = target.parentElement;
  if (parent) {
    // Remove the img element
    parent.removeChild(target);
    // Create a div for initials
    const initialsDiv = document.createElement("div");
    initialsDiv.className = "avatar-placeholder";
    initialsDiv.textContent = userInitials.value;
    parent.appendChild(initialsDiv);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "nav-item",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/resumes",
        class: "nav-item",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/cover-letters",
        class: _normalizeClass(["nav-item", {
          active:
            _ctx.$route.name === 'CoverLetterGenerator' || _ctx.$route.path.startsWith('/cover-letters'),
        }]),
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/interview-practice",
        class: _normalizeClass(["nav-item", { active: _ctx.$route.name === 'InterviewPractice' }]),
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/stats",
        class: "nav-item",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _hoisted_13
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/taskboard",
        class: "nav-item",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _hoisted_15
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/feedback",
        class: "nav-item",
        "active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_16,
          _hoisted_17
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("span", _hoisted_21, _toDisplayString(jbUser.value?.subscriptionPlan != null ? humanisePlan(jbUser.value.subscriptionPlan) : "Free") + " Plan", 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("span", null, _toDisplayString(applicationQuota.value.usage) + " / " + _toDisplayString(applicationQuota.value.quota), 1)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", {
          class: "progress-bar bg-primary",
          style: _normalizeStyle({ width: `${(applicationQuota.value.usage / applicationQuota.value.quota) * 100}%` })
        }, null, 4)
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showSubscribeModal.value = true)),
        class: _normalizeClass(["btn btn-outline-secondary w-100", { 'upgrade-needed': applicationQuota.value.usage >= applicationQuota.value.quota }])
      }, " Upgrade plan ", 2),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showSubscribeModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal fade show",
              style: {"display":"block","background":"rgba(0, 0, 0, 0.5)"},
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showSubscribeModal.value = false), ["self"]))
            }, [
              _createVNode(Subscribe, {
                "is-modal": true,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (showSubscribeModal.value = false))
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (_unref(user))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(user).picture,
                    alt: "User avatar",
                    onError: handleImageError,
                    style: {"width":"100%","height":"100%","object-fit":"cover"}
                  }, null, 40, _hoisted_28))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(userInitials.value), 1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(user).name), 1),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("ul", _hoisted_34, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'Profile' },
                  class: "dropdown-item"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _createTextVNode("Account ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_36,
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  onClick: logout,
                  href: "#",
                  class: "dropdown-item"
                }, [
                  _hoisted_37,
                  _createTextVNode("Logout ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})